import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@services/apis/api.service';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class AuthApiService {
	constructor(
		private apiSv: ApiService,
		private http: HttpClient,
	) {}
}
